import { z } from 'zod';

import { duplicateNameRefinement } from '@/modules/onboarding/common/utils/duplicate-name-refinement';

export const employeeSchema = (t: (key: string, options?: any) => string) =>
  z.object({
    name: z
      .string()
      .trim()
      .min(1, {
        message: t('authenticated.onboarding.team:validation.name.required'),
      })
      .min(2, {
        message: t('authenticated.onboarding.team:validation.name.min', {
          min: 2,
        }),
      }),
    email: z
      .string()
      .trim()
      .optional()
      .refine(val => !val || z.string().email().safeParse(val).success, {
        message: t('authenticated.onboarding.team:validation.email.invalid'),
      }),
  });

export const employeesTableSchema = (t: (key: string, options?: any) => string) =>
  z.object({
    employees: z
      .array(employeeSchema(t))
      .superRefine(
        duplicateNameRefinement(
          e => e.name,
          'name',
          t('authenticated.onboarding.team:validation.name.duplicate')
        )
      )
      .superRefine(
        duplicateNameRefinement(
          e => e.email ?? '',
          'email',
          t('authenticated.onboarding.team:validation.email.duplicate')
        )
      ),
  });

export type EmployeeFormValues = z.infer<ReturnType<typeof employeeSchema>>;
export type EmployeesTableFormValues = z.infer<ReturnType<typeof employeesTableSchema>>;
